class LocalStorageWrapper {
  setItem(key, value) { localStorage.setItem(key, value); }
  getItem(key) { return localStorage.getItem(key); }
  removeItem(key) { localStorage.removeItem(key); }
  clear() { localStorage.clear(); }
}

export class StorageManager {
  static getStorage() {
    if (!StorageManager.storage) {
      StorageManager.storage = new LocalStorageWrapper();
    }
    return StorageManager.storage;
  }
  static setStorage(storage) {
    StorageManager.storage = storage;
  }
}
StorageManager.storage = null;
